import { Typography, useTheme } from '@mui/material';

/**
 * The properties for section typography
 */
interface SectionTypographyProps {
  /**
   * The title to use for the section typography
   */
  title: string;
}

/**
 * Typography to use within sections
 */
const SectionTypography = ({ title }: SectionTypographyProps) => {
  const theme = useTheme();

  return (
    <Typography
      color={theme.palette.text.primary}
      fontWeight="800"
      fontSize="1.25em"
    >
      {title}
    </Typography>
  );
};

export default SectionTypography;
